import type {Translations} from '../../server/chat';

export const translations: Translations = {
	strings: {
		"Hello! The global staff team would be happy to help you, but you need to explain what's going on first.": "",
		"Please post the information I requested above so a global staff member can come to help.": "",
		"Thank you for the information, global staff will be here shortly. Please stay in the room.": "",
		"You are banned from creating tickets": "",
		", because you have the same IP as ${ticket.banned}.": "",
		"Request help from global staff": "",
		"Please <button name=\"login\" class=\"button\">Log In</button> to request help.": "",
		"Request Help": "",
		"You already have a Help ticket.": "",
		"Back": "",
		"What's going on?": "",
		"Global staff cannot make Help requests. This form is only for reference.": "",
		"Abuse of Help requests can result in punishments.": "",
		"What do you want to report someone for?": "",
		"If someone is harassing you in private messages (PMs), click the button below and a global staff member will take a look. If you are being harassed in a chatroom, please ask a room staff member to handle it. If it's a minor issue, consider using <code>/ignore [username]</code> instead.": "",
		"If someone is harassing you in a battle, click the button below and a global staff member will take a look. If you are being harassed in a chatroom, please ask a room staff member to handle it. If it's a minor issue, consider using <code>/ignore [username]</code> instead.": "",
		"Please save a replay of the battle if it has ended, or provide a link to the battle if it is still ongoing.": "",
		"If a user has an inappropriate name, click the button below and a global staff member will take a look.": "",
		"If a user has inappropriate Pokemon nicknames, click the button below and a global staff member will take a look.": "",
		"What would you like to appeal?": "",
		"Permalocks are usually for repeated incidents of poor behavior over an extended period of time, and rarely for a single severe infraction. Please keep this in mind when appealing a permalock.": "",
		"Please visit the <a href=\"https://www.smogon.com/forums/threads/discipline-appeal-rules.3583479/\">Discipline Appeals</a> page to appeal your permalock.": "",
		"If you want to appeal your lock or namelock, click the button below and a global staff member will be with you shortly.": "",
		"If you are locked or namelocked under a name you don't recognize, click the button below to call a global staff member so we can check.": "",
		"We automatically lock proxies and VPNs to prevent evasion of punishments and other attacks on our server. To get unlocked, you need to disable your proxy or VPN.": "",
		"Do you have an autoconfirmed account? An account is autoconfirmed when it has won at least one rated battle and has been registered for one week or longer.": "",
		"Login to your autoconfirmed account by using the <code>/nick</code> command in any chatroom, and the semilock will automatically be removed. Afterwards, you can use the <code>/nick</code> command to switch back to your current username without being semilocked again.": "",
		"If the semilock does not go away, you can try asking a global staff member for help. Click the button below to call a global staff member.": "",
		"If you don't have an autoconfirmed account, you will need to contact a global staff member to appeal your semilock. Click the button below to call a global staff member.": "",
		"Please PM the staff member who punished you. If you don't know who punished you, ask another room staff member; they will redirect you to the correct user. If you are banned or blacklisted from the room, use <code>/roomauth [name of room]</code> to get a list of room staff members. Bold names are online.": "",
		"Do not PM staff if you are locked (signified by the symbol <code>‽</code> in front of your username). Locks are a different type of punishment; to appeal a lock, make a help ticket by clicking the Back button and then selecting the most relevant option.": "",
		"Maybe one of these options will be helpful?": "",
		"If you lost your password, click the button below to request a password reset. We will need to clarify a few pieces of information before resetting the account. Please note that password resets are low priority and may take a while; we recommend using a new account while waiting.": "",
		"Request a password reset": "",
		"If you are a room driver or up in a public room, and you need help watching the chat, one or more global staff members would be happy to assist you!": "",
		"If your issue is not handled above, click the button below to talk to a global staff member. Please be ready to explain the situation.": "",
		"Malformed help request.": "",
		"PM Harassment": "",
		"Battle Harassment": "",
		"Inappropriate Username": "",
		"Inappropriate Pokemon Nicknames": "",
		"Appeal": "",
		"IP-Appeal": "",
		"ISP-Appeal": "",
		"Public Room Assistance Request": "",
		"Other": "",
		"I want to report someone": "",
		"Someone is harassing me in PMs": "",
		"Someone is harassing me in a battle": "",
		"Someone is using an offensive username": "",
		"Someone is using offensive Pokemon nicknames": "",
		"I want to appeal a punishment": "",
		"I want to appeal my permalock": "",
		"I want to appeal my lock": "",
		"I'm locked because I have the same IP as someone I don't recognize": "",
		"I can't talk in chat because of my ISP": "",
		"I'm locked because of a proxy or VPN": "",
		"Yes, I have an autoconfirmed account": "",
		"No, I don't have an autoconfirmed account": "",
		"I want to appeal a mute/roomban/blacklist": "",
		"Something else": "",
		"I lost my password": "",
		"I need global staff to help watch a public room": "",
		"Report harassment in a private message (PM)": "",
		"Report harassment in a battle": "",
		"Report an inappropriate username": "",
		"Report inappropriate Pokemon nicknames": "",
		"Appeal your lock": "",
		"Appeal IP lock": "",
		"Appeal ISP lock": "",
		"Call a Global Staff member to help": "",
		"Call a Global Staff member": "",
		"Are you sure you want to submit a ticket for ${type}?": "",
		"Yes, contact global staff": "",
		"No, cancel": "",
		"Help Ticket Stats": "",
		"Help tickets": "",
		"Status": "",
		"Creator": "",
		"Ticket Type": "",
		"Language": "",
		"Claimed by": "",
		"Action": "",
		"And ${keys.length - count} more tickets.": "",
		"View all tickets": "",
		"Closed": "",
		"Inactive": "",
		"Claimed": "",
		"Unclaimed": "",
		"Claim": "",
		"View": "",
		"Log": "",
		"Banned by": "",
		"Username": "",
		"Expires": "",
		"Logs": "",
		"And ${banKeys.length - count} more ticket bans.": "",
		"Ticket List": "",
		"Banned": "",
		"Ticket Stats": "",
		"No ticket stats found.": "",
		"Previous Month": "",
		"Staff Stats": "",
		"Next Month": "",
		"Resolved": "",
		"Unresolved": "",
		"Dead": "",
		"Type": "",
		"Total Tickets": "",
		"Average Total Time": "",
		"Average Initial Wait": "",
		"Average Total Wait": "",
		"Resolutions": "",
		"Positive Result": "",
		"Staff ID": "",
		"Number of Tickets": "",
		"Average Time Per Ticket": "",
		"This command cannot be broadcast in battles.": "",
		"Report someone": "",
		"Appeal a punishment": "",
		"Request help": "",
		"You need to choose a username before doing this. [TN: 'this' refers to opening a help ticket]": "",
		"Global staff can't make tickets. They can only use the form for reference.": "",
		"You already have an open ticket; please wait for global staff to respond.": "",
		"Due to high load, you are limited to creating ${maxTickets} tickets every hour.": "",
		"Hi! Who was harassing you in private messages?": "",
		"Hi! Who was harassing you, and in which battle did it happen? Please post a link to the battle or a replay of the battle.": "",
		"Hi! Tell us the username that is inappropriate.": "",
		"Hi! Which user has Pokemon with inappropriate nicknames, and in which battle? Please post a link to the battle or a replay of the battle.": "",
		"Hi! Can you please explain why you feel your punishment is undeserved?": "",
		"Hi! How are you connecting to Showdown right now? At home, at school, on a phone using mobile data, or some other way?": "",
		"Hi! Which room(s) do you need us to help you watch?": "",
		"Hi! What seems to be the problem? Tell us about any people involved,\n and if this happened in a specific place on the site.": "",
		"Hi! Please click the button below to give global staff permission to check PMs.": "",
		" Or if ${reportTarget} is not the user you want to report, please tell us the name of the user who you want to report.": "",
		"Help Ticket": "",
		"Issue": "",
		"A Global Staff member will be with you shortly.": "",
		"${inputUsername} does not have an open ticket.": "",
		"You closed ${ticket.creator}'s ticket.": "",
		"The reason is too long. It cannot exceed 300 characters.": "",
		"User '${targetUsername}' not found.": "",
		"${targetUser ? targetUser.name : target} is not ticket banned.": "",
		"${targetUser ? targetUser.name : target}'s ticket ban is already expired.": "",
		"You are already ignoring help ticket notifications. Use /helpticket unignore to receive notifications again.": "",
		"You are now ignoring help ticket notifications.": "",
		"You are not ignoring help ticket notifications. Use /helpticket ignore to stop receiving notifications.": "",
		"You will now receive help ticket notifications.": "",
		"${target} does not have a ticket.": "",
		"You deleted ${target}'s ticket.": "",

		"Hi! All global staff members are busy right now and we apologize for the delay. ": "",
		"Please make sure you have given us the permission to check the PMs between you and the user you reported. You can also provide any relevant context; for example, a replay of a battle with the person you're reporting.": "",
		'Please save the replay of the battle and provide a link to it in this chat, so we can see the harassment even if the battle expires. You can save the replay by clicking on the "Upload and share replay" button once the battle has ended.': "",
		"Make sure you have provided the correct username, and if its meaning or why it is offensive is not obvious, please explain why it should not be allowed.": "",
		'Please save the replay of the battle and provide a link to it in this chat, so we can see the nicknames even if the battle expires. You can save the replay by clicking on the "Upload and share replay" button once the battle has ended.': "",
		"Please clearly explain why you should be unlocked and we will review it as soon as possible.": "",
		"Please give us all relevant information on how you are connecting to Pokémon Showdown (if it is through mobile data, at home, a school or work network, etc), and we will review your case as soon as possible.": "",
		"Please tell us which room you need assistance with and a global staff member will join your room as soon as possible.": "",
		"If your issue pertains to battle mechanics or is a question about Pokémon Showdown, you can ask in the <<help>> chatroom.": "",
	},
};
